var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sl-amap',{staticClass:"map",attrs:{"zoom":5,"theme":"whitesmoke"},on:{"ready":_vm.handleReady}})}
var staticRenderFns = []

export { render, staticRenderFns }